import { useState } from "react";

import "./UnknownSwitch.css";

// '모르는 단어' 표시. 켜 두면 모르는 단어 카드에 모아 보여 준다(UnknownCardPage).
const UnknownSwitch = ({ initChecked, onChange }) => {
  const [checked, setChecked] = useState(Boolean(initChecked));

  const handleClick = () => {
    const nextChecked = !checked;
    setChecked(nextChecked);
    onChange(nextChecked);
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`unknown-switch${checked ? " is-checked" : ""}`}
      onClick={handleClick}
    >
      <span className="unknown-switch__mark">?</span>
      <span className="unknown-switch__label">모르는 단어</span>
    </button>
  );
};

export default UnknownSwitch;
